// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-page-auto-gallery-page-react-js": () => import("./../../../src/components/Page/AutoGalleryPage.react.js" /* webpackChunkName: "component---src-components-page-auto-gallery-page-react-js" */),
  "component---src-components-page-auto-page-react-js": () => import("./../../../src/components/Page/AutoPage.react.js" /* webpackChunkName: "component---src-components-page-auto-page-react-js" */)
}

